import extractSecretKey from '../data_management/extractSecretKey'
import deleteQuestionnaireInstance from '../data_management/deleteQuestionnaireInstance'
import addQuestionnaireInstancesToPerson from '../data_management/addQuestionnaireInstancesToPerson'
import invalidateLoadedData from '../data_management/invalidateLoadedData'
import { Loader } from '@mojility/core-es6'
import { DataKeys } from '../util/enumerations'

class PersonInteractor {

  constructor(initialDataInteractor, dataService, coachGateway) {
    this.initialDataInteractor = initialDataInteractor;
    this.dataService = dataService;
    this.coachGateway = coachGateway;

    this.loader = new Loader(
      dataService,
      () => this.coachGateway.getDataForCoachInterface(dataService.secretKey),
      [
        [DataKeys.People, data => data.people]
      ])
  }

  deleteQuestionnaireInstance(instanceId) {
    return this.coachGateway.deleteQuestionnaireInstance(extractSecretKey(this.initialDataInteractor), instanceId)
      .then(() => {
        deleteQuestionnaireInstance(this.initialDataInteractor, instanceId);
        return Promise.resolve();
      });
  }

  dischargeCoachee(coacheeId) {
    return this.coachGateway.dischargeCoachee(extractSecretKey(this.initialDataInteractor), coacheeId)
      .then(response => invalidateLoadedData(this.initialDataInteractor));
  }

  getQuestionnaireInstances(personId) {
    return this.coachGateway.getQuestionnaireInstancesForPerson(extractSecretKey(this.initialDataInteractor), personId)
      .then(response => {
        addQuestionnaireInstancesToPerson(this.initialDataInteractor, personId, response.questionnaire_instances);
        return response.questionnaire_instances;
      })
  }

  getPeople() {
    return this.loader.loadThroughCache(DataKeys.People);
  }

  getPerson(personId) {
    return this.getPeople().then(people => people.find(p => p.id == personId));
  }
}

export default PersonInteractor;